import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import './ISODirectoryComponent.css';

const ISODirectoryComponent = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedLink, setSelectedLink] = useState('');
  const navigate = useNavigate();

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const handleLinkClick = (link) => {
    setSelectedLink(`ISO360@Think5Whys ${link.text}`);
    navigate(link.route);
  };

  const links = [
    { text: 'ISO Standards', route: '/iso360-standardlist' },
    { text: 'ISO Processes', route: '/iso360-processlist' },
    { text: 'ISO Certified Companies', route: '/iso360-certifiedcompanies' },
    { text: 'ISO Company Certification History', route: '/iso360-certificationhistory' },
    { text: 'ISO Company Policy Board', route: '/iso360-policyboard' },
    { text: 'ISO Certification Agencies', route: '/iso360-certificationagencies' },
    { text: 'ISO Auditors', route: '/iso360-auditors' },
    { text: 'ISO Jobs', route: '/iso360-jobs' },
    { text: 'ISO Assignments', route: '/iso360-assignments' },
    { text: 'ISO Wiki', route: '/iso360-wiki' },
    { text: 'ISO Blogs', route: '/iso360-blogs' },
    { text: 'ISO Forum', route: '/iso360-forum' },
    { text: 'ISO News', route: '/iso360-news' },
    { text: 'ISO Success Stories', route: '/iso360-successstories' }
  ];

  return (
    <div className="iso-directory">
      <div className="search-box">
        <input
          type="text"
          placeholder="Search in ISO360@Think5Whys..."
          value={searchQuery}
          onChange={handleSearchChange}
        />
        <FontAwesomeIcon icon={faSearch} className="search-icon" />
      </div>
      <div className="links">
        {links.map((link, index) => (
          <span
            key={index}
            className={`link ${selectedLink === `ISO360@Think5Whys ${link.text}` ? 'selected' : ''}`}
            onClick={() => handleLinkClick(link)}
          >
            {link.text}
          </span>
        ))}
      </div>
      {selectedLink && <div className="selected-link text-blue-500 font-bold underline">{selectedLink}</div>}
    </div>
  );
};

export default ISODirectoryComponent;
